import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../../common/ModalDialog';

export type ConfirmAlertProps = {
    showAlert: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    alertText: string;
    title?: string;
};

const ConfirmAlert = ({
    showAlert,
    onConfirm,
    onCancel,
    alertText,
    title
}: ConfirmAlertProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <ModalDialog
            showDialog={showAlert}
            title={title || t('confirm_cancel')}
            primaryButton={{
                text: t('confirm'),
                disabled: false,
                onClick: onConfirm
            }}
            secondaryButton={{
                text: t('cancel'),
                onClick: onCancel
            }}
            onCloseClick={onCancel}>
            {alertText}
        </ModalDialog>
    );
};

export default ConfirmAlert;
